import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Target, Mail } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function XclusiveAgentLeads() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-491">
      <div className="max-w-6xl mx-auto px-4" data-id="element-492">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-493">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-494" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-495">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-496">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-497">
              Paid Media
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-498">
              Retargeting
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-499">
              E-Commerce
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-500">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-501">
            Dominating Agent Lead Gen With a Full-Funnel System
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-502">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-503">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-504">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-505">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-506" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-507">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-508">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-509" />
                </div>
                <div data-id="element-510">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-511">
                    +18%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-512">
                    Sales Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-513">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-514">
                <Target className="w-24 h-24 text-engage-yellow" data-id="element-515" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-516">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-517">
                  <Target className="w-6 h-6 text-engage-yellow" data-id="element-518" />
                </div>
                <div data-id="element-519">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-520">
                    5.36x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-521">
                    Blended ROAS
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-522">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-523">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-524" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-525">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-526">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-527" />
                </div>
                <div data-id="element-528">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-529">
                    +67%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-530">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-531">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-532">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-533">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-534" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-535">
              The Christmas Palace needed their "Christmas in July" campaign to
              perform like peak season—without sacrificing profitability or
              brand perception. With growing traffic but under-converting
              add-to-carts, the challenge was clear: scale revenue across Meta,
              Google, and email simultaneously while maintaining efficiency,
              strong ROAS, and a premium customer experience.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-536">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-537">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-538" />
              <div className="relative z-10" data-id="element-539">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-540">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-541" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-542">
                  We built a campaign designed for performance at every level.
                  High-impact creative led the strategy, supported by a
                  multi-campaign paid media structure and aggressive testing
                  cycles that allowed us to scale what worked in real time. At
                  the same time, we re-engineered email into a high-frequency,
                  segmented conversion channel—ensuring demand was not only
                  captured, but fully monetized across every touchpoint.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-543">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-544" />
              <div className="relative z-10" data-id="element-545">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-546">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-547" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-548">
                  The campaign delivered strong, profitable growth in the middle
                  of the off-season—proving that demand could be created, not
                  just captured. Revenue increased, returning customer rate
                  surged, and performance remained efficient across all
                  channels. What is traditionally a slow period became a
                  high-performing revenue window, turning July into an extension
                  of peak season.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-549">
            <div className="flex justify-center mb-8" data-id="element-550">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-551">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-552" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-553">
              We turned the off-season into a revenue driver—making July perform
              like peak season.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-554">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 flex items-center justify-center overflow-hidden bg-gradient-to-br from-engage-gray2 to-engage-gray3" data-id="element-555">
                <svg className="w-9 h-9 md:w-11 md:h-11 text-engage-gray4" viewBox="0 0 24 24" fill="currentColor" data-id="element-556">
                  <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" data-id="element-557" />
                </svg>
              </div>
              <div className="font-bold text-engage-white text-lg" data-id="element-558">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-559">
                The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-560">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-561" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-562">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-563">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-564">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-565">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}